var app = angular.module('leonardo');

var RolesSelector = function (AuthDataService, AccountUserRoleService, $q, $filter) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/role-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      inline: '@',
      account: '=?',
      validators: '=?',
      onRolesLoaded: '&?'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.multiple = true;
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      if (!isEmpty(scope.validators)) {
        scope.validations = (angular.isArray(scope.validators) ? scope.validators : [scope.validators]);
      }
      else {
        scope.validations = [];
      }
      scope.initRoles = function () {
        var defer = $q.defer();
        AuthDataService.getRolesValid(scope.account).then(function (roles) {
          scope.roles = roles;
          if(scope.onRolesLoaded) {
            scope.onRolesLoaded({roles: roles});
          }
          defer.resolve();
        });
        return defer.promise;
      };

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$modelValue;
        scope.roleBasedOnly = scope.value.role_based_only;
        scope.required = scope.value.role_based_only;
      };

      scope.ngModelCtrl.$validators.empty = function () {
        if (!scope.required) {
          return true;
        }

        if (scope.value.role_based_only) {
          if (angular.isArray(scope.value.roles)) {
            return scope.value.roles.length > 0 ? true : false;
          }
        } else {
          return true;
        }
      };

      angular.forEach(scope.validations, function (validator){
        if (validator.async) {
          scope.ngModelCtrl.$asyncValidators[validator.error] = function () {
            return validator.validation().then(function (result) {
              return result;
            });
          };
        }
        else {
          scope.ngModelCtrl.$validators[validator.error] = function () {
            return validator.validation();
          };
        }
        if (validator.eventWatch) {
          scope.$on(validator.eventWatch, function () {
            scope.ngModelCtrl.$validate();
          });
        }
      });

      scope.toggleRole = function (role) {
        if (scope.disabled) return;
        var list = angular.copy(scope.value.roles);
        if (scope.multiple) {
          if (!scope.value.roles) list = [];
          var index = list.indexOf(role.id);
          if (index >= 0) list.splice(index, 1);
          else list.push(role.id);
        } else list = role.id;
        scope.value.roles = list;
      };

      scope.isSelected = function (role) {
        if (scope.multiple) {
          return _.contains(scope.value.roles, role.id);
        } else {
          return role.id == scope.value;
        }
      };

      scope.roleBasedOnlySelect = function () {
        scope.roleBasedOnly = !scope.roleBasedOnly;
        if (scope.roleBasedOnly) {
          scope.required = scope.roleBasedOnly;
        }
        scope.value.role_based_only = scope.roleBasedOnly;
      };

      scope.$watch('account', function () {
        scope.initRoles().then(function () {
          scope.roleBasedOnly = scope.value.role_based_only;
          var ids = [];
          angular.forEach(scope.roles, function (role) {
            if (scope.multiple) {
              if (_.contains(scope.value.roles, role.id)) {
                ids.push(role.id);
              }
            } else {
              if (scope.value.roles == role.id) {
                ids = role.id;
              }
            }
          });
          scope.value.roles = ids;
        });
      });

      scope.$watch('value.roles', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.ngModelCtrl.$setViewValue(scope.value);
          scope.ngModelCtrl.$validate();
        }
      });

      scope.$watch('value.role_based_only', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.ngModelCtrl.$setViewValue(scope.value);
          scope.ngModelCtrl.$validate();
        }
      });
    }
  };
};

app.directive('rolesSelector', ['AuthDataService', 'AccountUserRoleService', '$q', '$filter', RolesSelector]);
